import report_thumbs from './extra_assets/json_maps/book_report_thumbnails.json'
export const thumbs = [... report_thumbs];